// hooks/useRemoveUserRole.ts
import { useMutation } from '@tanstack/react-query';
import { api } from 'api/v1/api';
import { useUserStore } from 'modules';
import { addNotification } from 'notifications/addNotification';
import { useLogout } from './use-logout';

interface RemoveRoleParams {
  roleId: string | number;
  customMessage?: string;
}

export const useRemoveUserRole = () => {
  const { user } = useUserStore();
  const logoutMutation = useLogout();

  return useMutation({
    mutationFn: async ({ roleId }: RemoveRoleParams) => {
      if (!user?.id) {
        throw new Error('User ID not found');
      }

      const response = await api.delete(`/users/${user.id}/role/${roleId}`);
      return response.data;
    },

    onSuccess: (_data, variables) => {
      // Кастомное уведомление
      if (variables.customMessage) {
        addNotification(variables.customMessage, 'success');
      } else {
        addNotification('Роль успешно удалена', 'success');
      }

      // Запускаем logout
      logoutMutation.mutate();
    },

    onError: (error: any) => {
      addNotification('При удаление что-то пошло не так', 'error');

      console.error('Ошибка при удалении роли:', error);
      // useLogout.onError уже покажет уведомление
    },
  });
};
